module.exports = "<button [class.is-loading]=\"isLoading\" [ngClass]=\"classlist\" (click)=\"onclickbutton($event)\" [disabled]=\"isLoading\">\n  <div class=\"loader-inner\"><div></div><div></div><div></div><div></div></div>\n  <span class=\"text-inner\">{{label}}</span>\n</button>"


//////////////////
// WEBPACK FOOTER
// ./src/app/vqforms/submit-button/submit-button.component.html
// module id = ./src/app/vqforms/submit-button/submit-button.component.html
// module chunks = main